import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/shared/services/auth.service';
import { RegistrationPaymentService } from 'src/shared/services/registration-payment.service';
import { ResponseService } from 'src/shared/services/response-service.service';
import { TranslateService } from 'src/shared/services/translate.service';

@Component({
  selector: 'app-payment-accumulation-setup',
  templateUrl: './payment-accumulation-setup.component.html',
  styleUrl: './payment-accumulation-setup.component.scss'
})
export class PaymentAccumulationSetupComponent implements OnInit {

  paramForm: FormGroup;
  checkboxForm!: FormGroup<{ [key: string]: FormControl<boolean> }>;
  columnsToDisplay = ['school_short_address', 'accumulation'];
  dataSchool: any[] = [];
  dataAccumulation: any[] = [];
  apiSubscription: Subscription;
  loading = false;
  isChecked = false;

  constructor(
      private translate: TranslateService,
      private paymentService: RegistrationPaymentService,
      private rpSer: ResponseService,
      public auth: AuthService,
      private router: Router,
      private route: ActivatedRoute
    ){}

   ngOnInit(): void {
    this.auth.loadPermissions(true);
    this.translate.load('extracurricular');
    this.loading = true;
    this.initForm();
  }

  viewAccumulationSetup() {
    this.router.navigate(['accumulation-setup'], { relativeTo: this.route });
  }
  
  initForm() {
    this.paramForm = new FormGroup({
      'academic_year': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_level_id': new FormControl(null),
    });
  }

  onChangeAcademicYear(item: any) {
    this.paramForm.controls['academic_year'].markAsTouched();
    this.paramForm.controls['academic_year'].setValue(item ? item.academic_year : null);
  }

  // onChangeSchoolLevel(item: any) {
  //   this.paramForm.controls['school_location_id'].markAsTouched();
  //   this.paramForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

  //   this.paramForm.controls['school_level_id'].markAsTouched();
  //   this.paramForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);
  // }

  getLocationAccumulationData() {
    if (this.apiSubscription) {
      this.apiSubscription.unsubscribe();
    }
    const schoolLocationIds = this.dataSchool.map(item => +item.school_location_id);
    this.loading = true;
    this.apiSubscription = this.paymentService.getAccumulationPaymentSetup({school_location_ids: schoolLocationIds, academic_year: this.paramForm.controls['academic_year'].value }).subscribe(
      (response: any) => {
        if (response.status) {
          this.dataAccumulation = response.data;
          const group: { [key: string]: FormControl } = {};
          this.dataAccumulation.forEach(item => {
            group[item.school_location_id] = new FormControl(item.accumulation ? true : false );
          });
          this.checkboxForm = new FormGroup(group);
        } else {
          this.rpSer.showAddError(response.message);
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.rpSer.showAddError();
      }
    );
  }

  checkAllCheckboxes() {
    this.isChecked = !this.isChecked;

    Object.keys(this.checkboxForm.controls).forEach(key => {
      const control = this.checkboxForm.controls[key];
      const item = this.dataAccumulation.find(p => p.school_location_id == +key);

      if (!item?.payment_generated) {
        control.setValue(this.isChecked);
      }
    });
  }

  getSelectedCheckboxes(): any[] {
    return Object.keys(this.checkboxForm.controls)
      .map(key => {
        const item = this.dataAccumulation.find(p => p.school_location_id == +key);
        return {
          payment_accumulation_mapping_id: +item.payment_accumulation_mapping_id,
          school_location_id: +item.school_location_id,
          academic_year: this.paramForm.controls['academic_year'].value,
          accumulation: !!this.checkboxForm.controls[key].value,
        };
      });
  }

  onGetEventSchoolLocation(data: any) {
    this.dataSchool = data;
    this.getLocationAccumulationData();
  }

  onSaveAccumulationSetup() {
    const selected = this.getSelectedCheckboxes();
    this.apiSubscription = this.paymentService.saveAccumulationPaymentSetup(selected).subscribe(
      (response: any) => {
        if (response.status) {
          this.rpSer.showEditSuccess();
          this.getLocationAccumulationData();
        } else {
          this.rpSer.showAddError(response.message);
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.rpSer.showAddError();
      }
    );
  }

}
